import { ChevronDown16Icon } from '@jablotron/lib.spa-icons/icons/chevron-down-16';
import { type ReactNode, useState } from 'react';

type FooterAccordionSectionProps = {
  title: ReactNode;
  children: ReactNode;
};

/** Mobile-collapsible footer section: collapsed by default below `sm`, always expanded at `sm` and above. */
export function FooterAccordionSection({ title, children }: FooterAccordionSectionProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
        data-testid="footer-accordion-heading"
        className="flex w-full cursor-pointer items-center justify-between gap-2 border-none bg-transparent p-0 text-left text-sm font-semibold text-white sm:cursor-default"
      >
        {title}
        <ChevronDown16Icon
          width={16}
          height={16}
          aria-hidden
          className={`shrink-0 transition-transform sm:hidden ${expanded ? 'rotate-180' : ''}`}
        />
      </button>

      <div data-testid="footer-accordion-content" className={`mt-4 sm:mt-0 ${expanded ? 'block' : 'hidden'} sm:block`}>
        {children}
      </div>
    </div>
  );
}
